import React from 'react'
import ReactMarkdown from 'react-markdown'
import PrismCode from 'react-prism'
import styled from 'styled-components'
import Image from './Image'

// prismjs imports
import 'prismjs'
import '../static/editor.css'
import 'prismjs/components/prism-javascript'
import 'prismjs/components/prism-css'
import 'prismjs/components/prism-scss'
import 'prismjs/components/prism-jsx'
import 'prismjs/components/prism-json'

const ImageContainer = styled.span`
  display: block;
  margin: 3.5em 0;
`

const ImageRenderer = ({ src, alt }) => {
  const lowres = `${src}?w=240`
  const highres = `${src}?w=640`
  return (
    <ImageContainer>
      <noscript>
        <img
          src={src}
          alt={alt}
          style={{
            maxWidth: '100%',
            padding: 15
          }}
        />
      </noscript>
      <Image width={640} height={640} alt={alt} src={highres} preview={lowres} lazyload />
    </ImageContainer>
  )
}

const ParagraphRenderer = ({ children }) => {
  const hasImage = !!children.find((child) => typeof child === 'object' && child.key && !!child.key.match(/image/g))
  return hasImage ? children : <p>{children}</p>
}

const Code = ({ lang, value }) => (
  <PrismCode component='pre' className={`code language-${lang}`}>
    {value}
  </PrismCode>
)

const CodeRenderer = (props) => {
  const { language = '', value = '' } = props
  if (language) {
    switch (language.toLowerCase()) {
      case 'js':
      case 'javascript':
        return <Code lang='javascript' value={value} />
      case 'css':
        return <Code lang='css' value={value} />
      case 'scss':
        return <Code lang='scss' value={value} />
      case 'jsx':
        return <Code lang='jsx' value={value} />
      case 'json':
        return <Code lang='json' value={value} />
      default:
        return (
          <pre>
            <code>{value}</code>
          </pre>
        )
    }
  } else if (value) {
    return (
      <pre>
        <code>{value}</code>
      </pre>
    )
  } else {
    return null
  }
}

export default (props) => (
  <ReactMarkdown
    renderers={{
      image: ImageRenderer,
      paragraph: ParagraphRenderer,
      code: CodeRenderer
    }}
    {...props}
  />
)
